import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateDriverDocumentEntity } from '../../domain/entities/CreateUpdateDriverDocumentEntity'
import { CreateUpdateDocumentsModel } from './CreateUpdateDocumentsModel'

export class CreateUpdateDriverDocumentModel extends CreateUpdateDriverDocumentEntity {
  constructor(dataDto: CreateUpdateDriverDocumentEntity) {
    super()
    const createUpdateDocumentsModel = dataDto.documents?.map(
      (document) => new CreateUpdateDocumentsModel(document)
    )
    mapEntityProperties<CreateUpdateDriverDocumentModel>(this, dataDto, {
      map: {
        documents: createUpdateDocumentsModel ?? []
      }
    })
  }
}
